import "./App.css";
import LayoutWrapper from "./components/layout/LayoutWrapper";
import { QueryClient, QueryClientProvider } from "react-query";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import LoginPage from "./pages/Login/LoginPage";
import Dashboard from "./pages/Dashboard";
import Vendors from "./pages/Vendors";
import Services from "./pages/Services";
import AddVendor from "./pages/Vendors/AddVendor";
import Cities from "./pages/Cities";
import AddCity from "./pages/Cities/AddCity";
import EditCity from "./pages/Cities/EditCity";
import Locations from "./pages/Locations";
import AddLocation from "./pages/Locations/AddLocation";
import EditLocation from "./pages/Locations/EditLocation";
import DeliverySlots from "./pages/DeliverySlots";
import AddDeliverySlot from "./pages/DeliverySlots/AddDeliverySlot";
import EditDeliverySlot from "./pages/DeliverySlots/EditDeliverySlot";
import PaymentMethods from "./pages/PaymentMethods";
import Status from "./pages/Status";
// import "react-toastify/dist/ReactToastify.css";
import LoadingPage from "./pages/LoadingPage";
import Demo from "./pages/Demo";
import Customers from "./pages/Customers/Customers";
import CustomerStatus from "./pages/Customers/CustomersStatus";
import { useSelector } from "react-redux";
import ThemeProvider from "./utils/theme";
import EditVendor from "./pages/Vendors/EditVendor";
import Queries from "./pages/Queries";
import BusinessEnquiries from "./pages/Queries/BusinessEnquiries";
import AddService from "./pages/Services/AddService";
import StoresIndex from "./pages/store"
import StoreStepper from "./pages/store/AddStore";
import EditStore from "./pages/store/EditStore";
import EditServiceConfig from "./pages/store/EditServices";
// import EditServiceConfigPage from "./pages/store/EditServices/editservice";
import AddStoreService from "./pages/store/EditServices/AddStoreService";
import EditService from "./pages/Services/EditService";
import TeamManagement from "./pages/TeamManagement";
import EditMeta from "./pages/store/EditMeta";
import Transactions from "./pages/Transactions/Transactions";
import AllTransactions from "./pages/Transactions/AllTransactions";
import TransactionsDetail from "./pages/Transactions/TransactionsDetail";
import Invoice from "./pages/Transactions/Invoice";
import { Toaster } from 'react-hot-toast';
import TransactionReport from "./pages/Transactions/TransactionReport";

// Initialize React Query client
const queryClient = new QueryClient();

function App() {
  // Define the routes with correct paths and components
  const ctx = useSelector((state) => state.auth);

  console.log(ctx, "ctx");
  const router = createBrowserRouter([
    {
      path: "/",
      element: <LayoutWrapper />,
      children: [
        {
          path: "",
          element: <Dashboard />,
        },
        {
          path: "/vendors",
          element: <Vendors />,
        },
        {
          path: "/vendors/add",
          element: <AddVendor />,
        },
        {
          path: "/vendors/edit/:cognitoId",
          element: <EditVendor />,
        },
        // {
        //   path: "/cities",
        //   element: <Cities />,
        // },
        // {
        //   path: "/cities/add",
        //   element: <AddCity />,
        // },
        // {
        //   path: "/cities/edit/:id",
        //   element: <EditCity />,
        // },
        // {
        //   path: "/locations",
        //   element: <Locations />,
        // },
        // {
        //   path: "locations/add",
        //   element: <AddLocation />,
        // },
        // {
        //   path: "locations/edit/:id",
        //   element: <EditLocation />,
        // },
        {
          path: "delivery-slots",
          element: <DeliverySlots />,
        },
        {
          path: "delivery-slots/add",
          element: <AddDeliverySlot />,
        },
        {
          path: "delivery-slots/edit/:id",
          element: <EditDeliverySlot />,
        }
        ,
        // {
        //   path: "payment-methods",
        //   element: <PaymentMethods />,
        // },
        {
          path: "Status",
          element: <Status />,
        },
        {
          path: "store",
          element: <StoresIndex />,
        },
        {
          path: "store/add",
          element: <StoreStepper />,
        },
        {
          path: "store/edit/:id",
          element: <EditStore />
        },
        {
          path: "store/:storeId/editService",
          element: <EditServiceConfig />
        },
        {
          path: "store/:storeId/editMeta",
          element: <EditMeta />
        },
        {
          path: "store/:storeId/add-service",
          element: <AddStoreService />
        },
        // { 
        //   path:"store/:storeId/editService/:configId",
        //   element:<EditServiceConfigPage /> 
        // },

        // {
        //   path: "Stores",
        //   element: <Stores />,
        // },
        // {
        //   path: "Stores/add",
        //   element: <AddStore />,
        // },
        // {
        //   path: "Stores/edit",
        //   element: <EditStores />,
        // },
        // {
        //   path: "Stores/editCost",
        //   element: <EditStoreCost />,
        // },
        // {
        //   path: "store-cost",
        //   element: <StoreCost />,
        // },
        // {
        //   path: "store-cost/add",
        //   element: <AddStoreCost />,
        // },
        // {
        //   path: "store-cost/edit/:id",
        //   element: <EditCost />,
        // },
        {
          path: "customer-queries",
          element: <Queries />,
        },
        {
          path: "business-enquiries",
          element: <BusinessEnquiries />,
        },
        {
          path: "customers",
          element: <Customers />,
        },
        {
          path: "customers/status/:id",
          element: <CustomerStatus />,
        },
        {
          path: "customers",
          element: <Customers />,
        },
        {
          path: "customers/status/:id",
          element: <CustomerStatus />,
        },
        {
          path: "demo",
          element: <Demo />,
        },
        {
          path: "/services",
          element: <Services />,
        },
        {
          path: "/services/edit/:id",
          element: <EditService />,
        },
        {
          path: "/services/add",
          element: <AddService />,
        },
        {
          path: "/team-management",
          element: <TeamManagement />,
        },
        {
          path: "/transactions",
          element: <Transactions />,
        },
        {
          path: "/all-transactions",
          element: <AllTransactions />,
        },
        {
          path: "/transaction-report",
          element: <TransactionReport />,
        },
      ],
    },
    {
      path: "/login",
      element: <LoginPage />,
    },
  ]);

  return (
    <ThemeProvider>
      <QueryClientProvider client={queryClient}>
        <LoadingPage />
        <Toaster
          position="top-center"
          reverseOrder={false}
          toastOptions={{
            success: {
              style: {
                background: "#10b981",
                color: "#fff",
                border: "1px solid #059669",
              },
              iconTheme: {
                primary: "#fff",
                secondary: "#10b981",
              },
            },
            error: {
              style: {
                background: "#ef4444",
                color: "#fff",
                border: "1px solid #dc2626",
              },
              iconTheme: {
                primary: "#fff",
                secondary: "#ef4444",
              },
            },
          }}
        />
        <RouterProvider router={router} />


      </QueryClientProvider>
    </ThemeProvider>
  );
}

export default App;
